module.exports = __webpack_public_path__ + "static/media/AI钢琴回复.b18807bc.png";